module.exports = __webpack_public_path__ + "static/media/6.70f88895.png";